<main>
  <div class="main-container">
    <div toastContainer></div>
    <router-outlet></router-outlet>
  </div>
</main>
